/**
 * Filter menu items based on user visibility settings
 * 
 * Rules:
 * - If no visibility config → show to everyone
 * - If visibility is set → show only to matching user types
 * 
 * @param {Array} menuItems - Array of menu items from API
 * @param {Object} user - User object from Redux state (can be null)
 * @returns {Array} - Filtered menu items
 */
export const filterMenuItemsByVisibility = (menuItems, user) => {
  if (!menuItems || !Array.isArray(menuItems)) {
    return [];
  }

  return menuItems.filter(item => {
    const visibility = item.visibility;

    if (!visibility || Object.values(visibility).every(v => v === false)) {
      return true;
    }

    if (visibility.user_guest === true && !user) {
      return true;
    }

    if (visibility.user_not_loyalty === true && user && !user.iecode) {
      return true;
    }

    if (visibility.user_loyalty === true && user && user.iecode) {
      return true;
    }

    return false;
  });
};